import type { IntegrationRun } from "../../shared/types";

export const mockRuns: IntegrationRun[] = [
  {
    id: "run-customer-001",
    jobId: "job-synapse-customer-daily",
    jobName: "Customer 360 Daily Load",
    sourceType: "SYNAPSE",
    sourceName: "synw-prod-dataops",
    externalRunId: "synapse-run-customer-001",
    workspaceName: "synw-prod-dataops",
    pipelineName: "Customer360DailyLoad",
    triggerName: "daily-0500",
    runGroupId: "group-customer-20260602",
    invokedBy: "ScheduleTrigger",
    expectedStartTime: "2026-06-02T05:00:00Z",
    actualStartTime: "2026-06-02T05:03:00Z",
    endTime: "2026-06-02T05:41:00Z",
    durationMinutes: 38,
    status: "SUCCEEDED",
    severity: "HIGH",
    owner: "Samuel Kim",
    rawPayloadPath: "/integration-monitor/raw/source=synapse/year=2026/month=06/day=02/run-customer-001.json",
    lastCheckedAt: "2026-06-02T05:43:00Z"
  },
  {
    id: "run-finance-019",
    jobId: "job-synapse-finance-close",
    jobName: "Finance Close Pipeline",
    sourceType: "SYNAPSE",
    sourceName: "synw-prod-finance",
    externalRunId: "synapse-run-finance-019",
    workspaceName: "synw-prod-finance",
    pipelineName: "FinanceClosePipeline",
    triggerName: "weekday-0630",
    runGroupId: "group-finance-20260602",
    invokedBy: "ScheduleTrigger",
    expectedStartTime: "2026-06-02T06:30:00Z",
    actualStartTime: "2026-06-02T06:35:00Z",
    endTime: "2026-06-02T07:16:00Z",
    durationMinutes: 41,
    status: "FAILED",
    severity: "CRITICAL",
    lastError: "Copy activity failed: source ledger export returned schema version 18, expected 17.",
    owner: "Samuel Kim",
    rawPayloadPath: "/integration-monitor/errors/source=synapse/year=2026/month=06/day=02/run-finance-019.json",
    lastCheckedAt: "2026-06-02T07:18:00Z"
  },
  {
    id: "run-inventory-044",
    jobId: "job-synapse-inventory-hourly",
    jobName: "Inventory Availability Sync",
    sourceType: "SYNAPSE",
    sourceName: "synw-prod-supply",
    externalRunId: "synapse-run-inventory-044",
    workspaceName: "synw-prod-supply",
    pipelineName: "InventoryAvailabilitySync",
    triggerName: "hourly",
    runGroupId: "group-inventory-20260602-13",
    invokedBy: "ScheduleTrigger",
    expectedStartTime: "2026-06-02T13:00:00Z",
    actualStartTime: "2026-06-02T13:03:00Z",
    durationMinutes: 11,
    status: "RUNNING",
    severity: "MEDIUM",
    owner: "Samuel Kim",
    rawPayloadPath: "/integration-monitor/raw/source=synapse/year=2026/month=06/day=02/run-inventory-044.json",
    lastCheckedAt: "2026-06-02T13:14:00Z"
  },
  {
    id: "run-vendor-expected-031",
    jobId: "job-synapse-vendor-nightly",
    jobName: "Vendor Compliance Extract",
    sourceType: "SYNAPSE",
    sourceName: "synw-prod-partner",
    workspaceName: "synw-prod-partner",
    pipelineName: "VendorComplianceExtract",
    triggerName: "nightly-0330",
    expectedStartTime: "2026-06-02T03:30:00Z",
    status: "MISSING",
    severity: "HIGH",
    lastError: "No matching pipeline run found after grace period.",
    owner: "Samuel Kim",
    lastCheckedAt: "2026-06-02T04:02:00Z"
  },
  {
    id: "run-orders-208",
    jobId: "job-synapse-orders-late",
    jobName: "Orders Operational Feed",
    sourceType: "SYNAPSE",
    sourceName: "synw-prod-commerce",
    externalRunId: "synapse-run-orders-208",
    workspaceName: "synw-prod-commerce",
    pipelineName: "OrdersOperationalFeed",
    triggerName: "daily-1000",
    runGroupId: "group-orders-20260602",
    invokedBy: "ScheduleTrigger",
    expectedStartTime: "2026-06-02T10:00:00Z",
    actualStartTime: "2026-06-02T10:23:00Z",
    endTime: "2026-06-02T10:46:00Z",
    durationMinutes: 23,
    status: "LATE",
    severity: "MEDIUM",
    lastError: "Pipeline start exceeded configured grace period by 13 minutes.",
    owner: "Samuel Kim",
    rawPayloadPath: "/integration-monitor/raw/source=synapse/year=2026/month=06/day=02/run-orders-208.json",
    lastCheckedAt: "2026-06-02T10:47:00Z"
  },
  {
    id: "run-risk-312",
    jobId: "job-synapse-risk-long-running",
    jobName: "Risk Scoring Batch",
    sourceType: "SYNAPSE",
    sourceName: "synw-prod-risk",
    externalRunId: "synapse-run-risk-312",
    workspaceName: "synw-prod-risk",
    pipelineName: "RiskScoringBatch",
    triggerName: "weekday-1100",
    runGroupId: "group-risk-20260602",
    invokedBy: "ScheduleTrigger",
    expectedStartTime: "2026-06-02T11:00:00Z",
    actualStartTime: "2026-06-02T11:04:00Z",
    durationMinutes: 64,
    status: "LONG_RUNNING",
    severity: "CRITICAL",
    lastError: "Run is still active and has exceeded the 30 minute expected duration.",
    owner: "Samuel Kim",
    rawPayloadPath: "/integration-monitor/raw/source=synapse/year=2026/month=06/day=02/run-risk-312.json",
    lastCheckedAt: "2026-06-02T12:04:00Z"
  },
  {
    id: "run-marketing-096",
    jobId: "job-synapse-marketing-cancelled",
    jobName: "Marketing Attribution Refresh",
    sourceType: "SYNAPSE",
    sourceName: "synw-prod-marketing",
    externalRunId: "synapse-run-marketing-096",
    workspaceName: "synw-prod-marketing",
    pipelineName: "MarketingAttributionRefresh",
    triggerName: "daily-0800",
    runGroupId: "group-marketing-20260602",
    invokedBy: "ManualCancel",
    expectedStartTime: "2026-06-02T08:00:00Z",
    actualStartTime: "2026-06-02T08:02:00Z",
    endTime: "2026-06-02T08:12:00Z",
    durationMinutes: 10,
    status: "CANCELLED",
    severity: "LOW",
    lastError: "Run cancelled during upstream maintenance window.",
    owner: "Samuel Kim",
    rawPayloadPath: "/integration-monitor/raw/source=synapse/year=2026/month=06/day=02/run-marketing-096.json",
    lastCheckedAt: "2026-06-02T08:12:00Z"
  },
  {
    id: "run-acr-build-553",
    jobId: "job-acr-image-build",
    jobName: "Data API Image Build",
    sourceType: "ACR",
    sourceName: "acrproddataops",
    externalRunId: "acr-task-run-build-553",
    pipelineName: "data-api-image-build",
    triggerName: "data-api",
    expectedStartTime: "2026-06-02T09:15:00Z",
    actualStartTime: "2026-06-02T09:16:00Z",
    endTime: "2026-06-02T09:24:00Z",
    durationMinutes: 8,
    status: "SUCCEEDED",
    severity: "MEDIUM",
    owner: "Samuel Kim",
    rawPayloadPath: "/integration-monitor/raw/source=acr/year=2026/month=06/day=02/task-image-build-553.json",
    lastCheckedAt: "2026-06-02T09:25:00Z"
  },
  {
    id: "run-acr-scan-117",
    jobId: "job-acr-base-image-scan",
    jobName: "Base Image Vulnerability Scan",
    sourceType: "ACR",
    sourceName: "acrprodsecurity",
    externalRunId: "acr-task-run-scan-117",
    pipelineName: "base-image-vulnerability-scan",
    triggerName: "base-images",
    expectedStartTime: "2026-06-02T12:00:00Z",
    actualStartTime: "2026-06-02T12:01:00Z",
    endTime: "2026-06-02T12:19:00Z",
    durationMinutes: 18,
    status: "FAILED",
    severity: "HIGH",
    lastError: "Task failed: base image digest did not pass vulnerability policy.",
    owner: "Samuel Kim",
    rawPayloadPath: "/integration-monitor/errors/source=acr/year=2026/month=06/day=02/task-scan-117.json",
    lastCheckedAt: "2026-06-02T12:21:00Z"
  },
  {
    id: "run-customer-000",
    jobId: "job-synapse-customer-daily",
    jobName: "Customer 360 Daily Load",
    sourceType: "SYNAPSE",
    sourceName: "synw-prod-dataops",
    expectedStartTime: "2026-06-01T05:00:00Z",
    actualStartTime: "2026-06-01T05:01:00Z",
    endTime: "2026-06-01T05:39:00Z",
    durationMinutes: 38,
    status: "SUCCEEDED",
    severity: "HIGH",
    owner: "Samuel Kim",
    lastCheckedAt: "2026-06-01T05:40:00Z"
  },
  {
    id: "run-customer-099",
    jobId: "job-synapse-customer-daily",
    jobName: "Customer 360 Daily Load",
    sourceType: "SYNAPSE",
    sourceName: "synw-prod-dataops",
    expectedStartTime: "2026-05-31T05:00:00Z",
    actualStartTime: "2026-05-31T05:04:00Z",
    endTime: "2026-05-31T05:48:00Z",
    durationMinutes: 44,
    status: "SUCCEEDED",
    severity: "HIGH",
    owner: "Samuel Kim",
    lastCheckedAt: "2026-05-31T05:49:00Z"
  },
  {
    id: "run-customer-098",
    jobId: "job-synapse-customer-daily",
    jobName: "Customer 360 Daily Load",
    sourceType: "SYNAPSE",
    sourceName: "synw-prod-dataops",
    expectedStartTime: "2026-05-30T05:00:00Z",
    actualStartTime: "2026-05-30T05:02:00Z",
    endTime: "2026-05-30T05:55:00Z",
    durationMinutes: 53,
    status: "FAILED",
    severity: "HIGH",
    lastError: "Sink write retry limit exceeded.",
    owner: "Samuel Kim",
    lastCheckedAt: "2026-05-30T05:57:00Z"
  }
];
